import React, { forwardRef } from 'react';
import { TextField } from '@mui/material';
import { NumericFormat } from 'react-number-format';

// 1. Custom Input Component Wrapper (The formatter)
// Export this component so it can be used directly in OutlinedInput
export const GermanNumericFormat = forwardRef(function GermanNumericFormat(props, ref) {
  const { onChange, ...other } = props;

  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      allowNegative={false}
      onValueChange={(values) => {
        // IMPORTANT: The value sent back is the clean numeric string 
        // (e.g., "1234.56"), not the German formatted string ("1.234,56").
        onChange({
          target: {
            name: props.name,
            value: values.value, 
          },
        });
      }}
      // --- German Formatting Rules ---
      thousandSeparator="." 
      decimalSeparator="," 
      isNumericString
      decimalScale={2} // Limit to 2 decimal places
    />
  );
});

// 2. Main Generic Component (Still exported for use as a standalone TextField)
export default function GermanNumberInput({
  value,
  onUpdate,
  label,
  className,
  textFieldProps = {},
}) {
  
  const handleChange = (event) => {
    // Note: If you remove 'fieldKey' from props, you need to adjust your onUpdate signature.
    // Assuming onUpdate only takes the new value:
    onUpdate(event.target.value); 
  };

  return (
    <TextField
    className={className}
      label={label}
      variant="outlined"
      fullWidth
      // Props controlled by the parent
      value={value}
      onChange={handleChange}
      
      // Spread any additional props (like error, helperText, etc.)
      {...textFieldProps}

      // Tell TextField to use our custom formatter component
      InputProps={{
        inputComponent: GermanNumericFormat,
      }}
    />
  );
}